import { Blockquote } from './blockquote.jsx'

export * from './blockquote.jsx'

export default Blockquote
